function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(74,50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "#4C39DF",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.6666666666666666s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.6666666666666666s"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(62,70.78460969082653)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(59.99999999999999)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "#4C39DF",
  fillOpacity: 0.8333333333333334
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.5333333333333333s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.5333333333333333s"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.00000000000001,70.78460969082653)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(119.99999999999999)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "#4C39DF",
  fillOpacity: 0.6666666666666666
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.4000000000000001s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.4000000000000001s"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(26,50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "#4C39DF",
  fillOpacity: 0.5
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.26666666666666666s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.26666666666666666s"
}))));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.999999999999986,29.21539030917348)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(239.99999999999997)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "#4C39DF",
  fillOpacity: 0.3333333333333333
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.13333333333333333s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.13333333333333333s"
}))));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(62,29.215390309173472)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(300.00000000000006)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "#4C39DF",
  fillOpacity: 0.16666666666666666
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "0.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "0s"
}))));

var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader.06838af6.svg";
export { ForwardRef as ReactComponent };